import {DeserializedRecord, deserializeItem, Deserializer, deserializeSingleRelationship, JSONAPIRecord, JSONAPISingleRelationship} from "../Helpers";
import {Icd10Code} from "../icd10/code";

type RestrictionType = "inclusion" | "exclusion";
type NewRestrictionIcd10 = Pick<RestrictionIcd10, 'icd10Code' | 'restrictionType'>;

interface RestrictionIcd10 extends DeserializedRecord{
    icd10Code: Icd10Code,
    restrictionType: RestrictionType
}

interface RestrictionIcd10Data extends JSONAPIRecord {
    relationships: {
        icd10_code: JSONAPISingleRelationship
    }
}

const deserializeRestrictionIcd10: Deserializer<RestrictionIcd10, RestrictionIcd10Data> = (data, included) => {
  const icd10Code = deserializeSingleRelationship<Icd10Code>(data.relationships.icd10_code, included);

  return {
    ...deserializeItem(data),
    icd10Code: icd10Code
  };
};

export {
  RestrictionIcd10, deserializeRestrictionIcd10, NewRestrictionIcd10, RestrictionType
};
